/*
 * This function gets loaded when all the HTML, not including the portlets, is
 * loaded.
 */
AUI().ready(function () { });

/*
 * This function gets loaded after each and every portlet on the page.
 *
 * portletId: the current portlet's id
 * node: the Alloy Node object of the current portlet
 */
Liferay.Portlet.ready(function (_portletId, _node) { });

/*
 * This function gets loaded when everything, including the portlets, is on
 * the page.
 */
Liferay.on("allPortletsReady", function () {

  //get all the sections 
  const sections = $(".section-animation");

  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.2,
  };

  // on scroll load effect
  const sectionObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        $(entry.target).addClass("active-animation");
        observer.unobserve(entry.target);
      }
    });
  }, options);

  sections.each(function () {
    sectionObserver.observe(this);
  });

  $(window).on("beforeunload", function () {
    $(".section-animation").removeClass("active-animation");
  });

  // Function to get the ID from the URL
  function getIDFromURL() {
    const url = window.location.href;
    const hashIndex = url.indexOf('#');
    if (hashIndex !== -1) {
      return url.substring(hashIndex + 1);
    }
    return null;
  }

  // Function to scroll to the element with the specified ID
  function scrollToElement(elementID) {
    const element = $('#' + elementID);
    if (element.length) {
      $('html, body').animate({
        scrollTop: element.offset().top
      }, 1000);
    }
  }
  setTimeout(() => {
    // Get the ID from the URL and scroll to the corresponding div
    const idFromURL = getIDFromURL();
    if (idFromURL) {
      scrollToElement(idFromURL);
    } else {
      window.scrollTo(0, 0);
    }
  }, 2000);
});
